<template>
  <el-drawer
    v-model="dialogVisible"
    title="請選擇商品"
    direction="btt"
    :size="isMobile ? '85%' : 600"
    append-to-body
    :show-close="true"
    :before-close="handleClose"
  >
    <template #default>
      <div class="row">
        <div v-for="item in data" :key="data.id" class="col-lg-3 col-md-4 col-sm-4 col-6 my-2 p-1">
          <div class="-single-product-details d-flex align-items-end flex-column h-100 pb-3" style="border-radius:5px; border: 1px solid #eaeaea;">
            <div class="inline_product clickable d-flex justify-content-center"
              style="cursor: pointer;background:#3b71de10; border-radius: 5px 5px 0px 0px;"
            >
              <div class="d-flex justify-content-end for-dicount-div-null">
                <span class="for-discoutn-value-null"></span>
              </div>
              <div class="d-flex d-block" style="cursor: pointer;" @click="handleOk(item)">
                <el-image 
                  :src="imgProxy(item.image_url, rs='fill:250:250:1')"
                  :alt="dt(item.name_translations)"
                  style="width: 100%; border-radius:5px 5px 0px 0px;"
                >
                  <template #error>
                    <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(item.name_translations)" style="width: 100%;">
                  </template>
                </el-image>
              </div>
            </div>

            <div class="position-relative" style="padding-top:10px;">
              <div class="text-left pl-3 text-truncate-3" style="cursor: pointer;" @click="handleOk(item)">
                {{ dt(item.name_translations) }}
              </div>
              <div class="justify-content-between text-center">
                <div class="product-price text-center">
                  <del class="text-primary">{{ priceRange(item.price_range, "comm_price") }}</del>
                  <br>
                  <span class="text-accent">
                    {{ priceRange(item.price_range, "discounted_price") }}
                  </span>
                </div>
              </div>
            </div>

            <div class="mt-auto p-2 w-100">
              <button type="button" class="btn btn-primary btn-block mt-2" role="button" aria-disabled="true" @click="handleOk(item)">
                {{ t("global.ok") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, breakpoint, priceRange, imgProxy } from "../../utils"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Boolean,
  data: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue', 'ok'])
const dialogVisible = useVModel(props, 'modelValue', emit)

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)

const handleClose = () => {
  dialogVisible.value = false
}
const handleOk = (item) => {
  // console.debug("handleOk", item)
  emit("ok", item)
  handleClose()
}

</script>
